import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import Button from "../../../components/Button/Button";
import Buttons from "../../../components/Button/button.component";
import { selectLocale } from "../../../locales/localeSlice";
import { colors } from "../../../theme/color";
import { ButtonContainer } from "../General/ButtonHolder.styles";
import ServiceBubble from "../General/ServiceBubble/ServiceBubble";
import ListNumbering from "./ListNumbering";
import {
  ServiceLeftBlock,
  ServiceLeftContainer,
  ServiceLeftTextDown,
  ServiceLeftTextDownCarrier,
  ServiceLeftTextDownCarrierColumn,
  ServiceLeftTextUp,
  ServiceLeftTextholder,
  SmallSubtitleText,
  SmallTitleText,
  SubtitleText,
  TitleText,
} from "./ServiceLeft.styles";
import { useNavigate } from "react-router-dom";

const ServiceLeft = () => {
  const navigate = useNavigate();
  const redirectToSignup = () => {
    navigate("/auth/signup");
  };
  const { t } = useTranslation();
  const currentLocale = useSelector(selectLocale);
  return (
    <ServiceLeftContainer>
      <ServiceLeftBlock>
        <ServiceLeftTextholder>
          <ServiceBubble
            position="flex-start"
            label={t("servicesSection.paymentLinkLabel", {
              lng: currentLocale,
            })}
            backgroundColor="rgba(0, 199, 3, 0.1)"
          />
          <ServiceLeftTextUp>
            <TitleText>
              {t("servicesSection.titleText", { lng: currentLocale })}
            </TitleText>
            <SubtitleText>
              {t("servicesSection.subtitleTextOne", { lng: currentLocale })}
              <br />
              {t("servicesSection.subtitleTextTwo", { lng: currentLocale })}
            </SubtitleText>
          </ServiceLeftTextUp>
          <ServiceLeftTextDown>
            <ServiceLeftTextDownCarrier>
              <ListNumbering
                backgroundColor="#E5F9E6"
                text="1"
                textColor="secondary.main"
              />
              <ServiceLeftTextDownCarrierColumn>
                <SmallTitleText>
                  {" "}
                  {t("servicesSection.listTitleOne", { lng: currentLocale })}
                </SmallTitleText>
                <SmallSubtitleText>
                  {t("servicesSection.listTextLineOne", { lng: currentLocale })}
                  {t("servicesSection.listTextLineTwo", { lng: currentLocale })}
                </SmallSubtitleText>
              </ServiceLeftTextDownCarrierColumn>
            </ServiceLeftTextDownCarrier>

            <ServiceLeftTextDownCarrier>
              <ListNumbering
                backgroundColor="#E6E5EF"
                text="2"
                textColor="primary.main"
              />
              <ServiceLeftTextDownCarrierColumn>
                <SmallTitleText>
                  {" "}
                  {t("servicesSection.listTitleTwo", { lng: currentLocale })}
                </SmallTitleText>
                <SmallSubtitleText>
                  {t("servicesSection.listTextTwo", { lng: currentLocale })}
                  {t("servicesSection.listTextTwob", { lng: currentLocale })}
                </SmallSubtitleText>
              </ServiceLeftTextDownCarrierColumn>
            </ServiceLeftTextDownCarrier>

            <ServiceLeftTextDownCarrier>
              <ListNumbering
                backgroundColor="#E5F9E6"
                text="3"
                textColor="secondary.main"
              />
              <ServiceLeftTextDownCarrierColumn>
                <SmallTitleText>
                  {t("servicesSection.listTitleThree", { lng: currentLocale })}
                </SmallTitleText>
                <SmallSubtitleText>
                  {t("servicesSection.listTextThree", { lng: currentLocale })}
                  {t("servicesSection.listTextThreeb", { lng: currentLocale })}
                </SmallSubtitleText>
              </ServiceLeftTextDownCarrierColumn>
            </ServiceLeftTextDownCarrier>
          </ServiceLeftTextDown>
        </ServiceLeftTextholder>
        <ButtonContainer>
          <Button
            id={""}
            type={"button"}
            disabled={false}
            onClick={redirectToSignup}
            padding={"10px 30px"}
            title={t("servicesSection.buttonLabel", { lng: currentLocale })}
            navyBlue
          />
        </ButtonContainer>
      </ServiceLeftBlock>
    </ServiceLeftContainer>
  );
};

export default ServiceLeft;
